import { Header, SpaceBetween } from "@cloudscape-design/components-themed";
import Main from "./Main";

const PageHeader = ({ title }: { title: string }) => {
  return (
    <SpaceBetween size="m">
      <Header variant="h1">{title}</Header>
      <Main />
    </SpaceBetween>
  );
};

export default PageHeader;
